import React from "react";
import ReactModal from "react-modal";
import "./add-applications-modal.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ApplicationFormTab from "./partial/application-form-tab";
import PrevetFormTab from "./partial/prevet-form-tab";
import { withRouter } from "react-router-dom";
import EMSBoot from "./partial/ems-boot";
import EMSBootV2 from "./v2/EMSBoot";
import config from "../../../config";

const customStyles = {
    content: {
        minWidth: "1100px",
    },
};
class AddApplicationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editPrevet: this.props.editPrevet,
            preappId: this.props.editPrevetId,
        };
    }

    isDisabled = (errors) => {
        if (Array.isArray(errors) || this.state.formError === true) {
            return true;
        } else if (typeof errors === "object") {
            const values = Object.values(errors);
            if (values.length === 0) {
                return false;
            } else if (values.length > 0) {
                if (values.every((el) => el == "")) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    templateReset() {
        const formData = this.state.formData;
        formData["template_id"] = "";
        formData["price"] = "";
        formData["equipment"] = "";
        this.setState({ formData: formData, formError: true });
    }

    render() {

        return (
            <ReactModal
                isOpen={this.props.showCreatedAppModel}
                className="add-app-modal"
                style={
                    this.props.user.organization.id ===
                        config.paymentcloud.EMS_ORG_ID ||
                    this.props.user.organization.id ===
                        config.paymentcloud.PAYCHEX_ORG_ID
                        ? customStyles
                        : {}
                }
            >
                <div className="add-application-wrapper">
                    <div className="modal-body edit-organization">
                        <div className="editTab">
                            {this.props?.user?.channel == "sales_channel" ?
                                <>
                                    <ApplicationFormTab
                                        showCreatedAppModel={
                                            this.props
                                                .showCreatedAppModel
                                        }
                                        handleCloseCreatedAppModel={
                                            this.props
                                                .handleCloseCreatedAppModel
                                        }
                                        getPreappData={() =>
                                            this.props.getPreappData()
                                        }
                                        fullApplicationUrl={
                                            this.props.CreateUrl
                                        }
                                        user={this.props.user}
                                        editPrevetId={
                                            this.props.editPrevetId
                                        }
                                        editPrevet={
                                            this.props.editPrevet
                                        }
                                    />
                                </>
                                :
                                <Tabs defaultFocus={true} defaultIndex={0}>
                                    <TabList>
                                        {/* @todo this needs cleanup <Tab>EMS V2</Tab> */}
                                        {this.props.user.organization.id ===
                                            config.paymentcloud.EMS_ORG_ID ||
                                            this.props.user.organization.id ===
                                            config.paymentcloud.PAYCHEX_ORG_ID ? (
                                            <>{/* <Tab >EMS Boot</Tab> */}</>
                                        ) : (
                                            <>
                                                <Tab>Application</Tab>
                                                {!this.props.editPrevetId ? (
                                                    <Tab>Prevet</Tab>
                                                ) : null}
                                            </>
                                        )}
                                    </TabList>
                                    {/* <TabPanel>
                                    <EMSBootV2 close={this.props.handleCloseCreatedAppModel} />
                                </TabPanel> */}
                                    {this.props.user.organization.id ===
                                        config.paymentcloud.EMS_ORG_ID ||
                                        this.props.user.organization.id ===
                                        config.paymentcloud.PAYCHEX_ORG_ID ? (
                                        <>
                                            {/* <TabPanel>
                                        <EMSBoot close={this.props.handleCloseCreatedAppModel} />
                                    </TabPanel> */}
                                        </>
                                    ) : (
                                        <>
                                            <TabPanel>
                                                <ApplicationFormTab
                                                    showCreatedAppModel={
                                                        this.props
                                                            .showCreatedAppModel
                                                    }
                                                    handleCloseCreatedAppModel={
                                                        this.props
                                                            .handleCloseCreatedAppModel
                                                    }
                                                    getPreappData={() =>
                                                        this.props.getPreappData()
                                                    }
                                                    fullApplicationUrl={
                                                        this.props.CreateUrl
                                                    }
                                                    user={this.props.user}
                                                    editPrevetId={
                                                        this.props.editPrevetId
                                                    }
                                                    editPrevet={
                                                        this.props.editPrevet
                                                    }
                                                />
                                            </TabPanel>
                                            {!this.props.editPrevetId ? (
                                                <TabPanel>
                                                    <PrevetFormTab
                                                        showCreatedAppModel={
                                                            this.props
                                                                .showCreatedAppModel
                                                        }
                                                        handleCloseCreatedAppModel={
                                                            this.props
                                                                .handleCloseCreatedAppModel
                                                        }
                                                        getPreappData={() =>
                                                            this.props.getPreappData()
                                                        }
                                                        fullApplicationUrl={
                                                            this.props.CreateUrl
                                                        }
                                                        user={this.props.user}
                                                    />
                                                </TabPanel>
                                            ) : null}
                                        </>
                                    )}
                                </Tabs>
                            }
                        </div>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default withRouter(AddApplicationModal);
